var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlinefacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1920524_facebook_facebook icon_logo_network_icon 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0078 4.71963H7.95977V3.37705C7.95977 2.87119 8.29336 2.75361 8.52852 2.75361C8.76367 2.75361 9.975 2.75361 9.975 2.75361V0.536035L7.98438 0.527832C5.775 0.527832 5.27188 2.18213 5.27188 3.24033V4.71963H3.99219V7.00557H5.26914C5.26914 9.93955 5.26914 13.4724 5.26914 13.4724H7.95703C7.95703 13.4724 7.95703 9.904 7.95703 7.00557H9.76992L10.0078 4.71963Z",
    fill: "#23599C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinefacebook);
export default __webpack_public_path__ + "static/media/outlinefacebook.78ab81f602c94df455206bd083f80de8.svg";
export { ForwardRef as ReactComponent };